import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const ImageCarousel = ({
  items,
  selectedAngle,
  updatePartsConfig,
  allCategoryCustomizations,
  currentActiveParent,
  allBikeArtData
}) => {
  const [activeItem, setActiveItem] = useState(
    items.indexOf(items.find(part => part.partId === selectedAngle))
  );

  useEffect(() => {
    setActiveItem(
      items.indexOf(items.find(part => part.partId === selectedAngle))
    );
  }, [selectedAngle]);
  const viewCode = currentActiveParent === 'front' ? 'F' : 'B';

  const getOrder = item => {
    const name = item.name.split('_');
    const angle = name[viewCode === 'F' ? name.length - 1 : name.length - 2];
    switch (angle) {
      case 'FRONTVIEW':
        return 0;
      case 'SIDEVIEW':
        return 1;
      case 'BACKVIEW':
        return 2;
      default:
        return 0;
    }
  };

  const compare = (a, b) => {
    if (getOrder(a) < getOrder(b)) {
      return -1;
    } else if (getOrder(a) > getOrder(b)) {
      return 1;
    } else {
      return 0;
    }
  };

  const sortedItems = items.sort(compare);

  return (
    <div className="image-carousel">
      <div
        role="presentation"
        className={`image-carousel_leftbtn ${activeItem === 0 &&
          'image-carousel_leftbtn-disabled'}`}
        onClick={() => {
          if (activeItem !== 0) {
            setActiveItem(activeItem - 1);
            updatePartsConfig(
              items[activeItem - 1],
              'bikeArt',
              allBikeArtData
                .filter(
                  cust =>
                    !cust.customizationType ||
                    cust.customizationType !== 'angle' ||
                    (cust.customizationType === 'angle' &&
                      cust.partId[cust.partId.length - 1] !== viewCode)
                )
                .map(cust => cust.partId)
            );
          }
        }}
      >
        <svg
          width="15"
          height="15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.186 0l-7.5 7.5 7.5 7.5 2.128-2.128L6.94 7.5l5.373-5.372L10.186 0z"
            fill="#000"
          />
        </svg>
      </div>
      <div
        className={`image-carousel_rightbtn ${activeItem === items.length - 1 &&
          'image-carousel_rightbtn-disabled'}`}
        role="presentation"
        onClick={() => {
          if (activeItem !== items.length - 1) {
            setActiveItem(activeItem + 1);
            updatePartsConfig(
              items[activeItem + 1],
              'bikeArt',
              allBikeArtData
                .filter(
                  cust =>
                    cust.customizationType !== 'angle' ||
                    (cust.customizationType === 'angle' &&
                      cust.partId[cust.partId.length - 1] !== viewCode)
                )
                .map(cust => cust.partId)
            );
          }
        }}
      >
        <svg
          width="15"
          height="15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4.814 15l7.5-7.5-7.5-7.5-2.128 2.128L8.06 7.5l-5.373 5.372L4.814 15z"
            fill="#000"
          />
        </svg>
      </div>
      <div className="image-carousel_wrap">
        {sortedItems.map((item, i) => (
          <>
            <div
              role="presentation"
              className={`image-carousel_item ${activeItem === i &&
                'image-carousel_item-active'}`}
            >
              <div
                className="image-carousel_item_image"
                style={{
                  backgroundImage: `url(${item.configData.thumbnail})`
                }}
              />
            </div>
          </>
        ))}
      </div>
    </div>
  );
};

ImageCarousel.propTypes = {
  items: PropTypes.array
};

export default ImageCarousel;
